import Antd from 'ant-design-vue';
import alpButton from '../components/alp-components/alp-button/button.vue'

const alpUI = {}
alpUI.install = function(Vue){
	Vue.use(Antd);
	Vue.component(alpButton.name, alpButton);
}

import "./style/index.css";

export {
	Antd,
	alpButton,
};

export default alpUI;
